import {useCallback, useEffect, useState} from "react";

import {getRules} from "../api/rule";
import {Rule} from "../model/types";

type UseRulesProps = {
  userToken: string;
};

export const useRules = ({userToken}: UseRulesProps) => {
  const [rules, setRules] = useState<Rule[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchRules = useCallback(async () => {
    try {
      setIsLoading(true);
      const data = await getRules(userToken);
      setRules(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [userToken]);

  useEffect(() => {
    if (userToken) {
      fetchRules();
    }
  }, [userToken, fetchRules]);

  return {
    rules,
    isLoading,
    fetchRules,
  };
};
